/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { ModalHeader } from 'reactstrap';
import { addBoard, editBoard } from '../../apis/admin/newsletter';
import useForm from '../../hooks/useForm';
import { dateToFormat } from "../../utils/date";
import systemAlert from '../../utils/systemAlert';
import { toast } from '../../utils/toast';
import Form from '../Form';
import Modal from '../Modal';

const defaultForm = {
  title: "",
  content: "",
  date: dateToFormat(),
  isHide: "false",
  isEmail: "false",
};

const Board = (props) => {
  const { selectedItem, setSelectedItem, open, setOpen, submit } = props;
  const [fields, setFields] = useState([]);
  const [mode, setMode] = useState('create');

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    if (setSelectedItem) {
      setSelectedItem(null);
    }
  };

  useEffect(() => {
    setFields([
      {
        title: "제목",
        key: "title",
        type: "input",
        required: true,
      },
      {
        title: "노출일",
        key: "date",
        type: "datepicker",
        required: true,
      },
      [
        {
          title: "목록 노출 여부",
          key: "isHide",
          type: "radio",
          options: {
            list: [{ label: '노출', value: "false" }, { label: '숨김', value: "true" }]
          },
        },
        {
          title: "이메일 발송 가능 여부",
          key: "isEmail",
          type: "radio",
          options: {
            list: [{ label: '발송 가능', value: "true" }, { label: '발송 불가능', value: "false" }]
          },
        },
      ],
      {
        title: "내용",
        key: "content",
        type: "editor",
        required: true,
        readOnly: mode !== "create",
        // onChange: (e) => {
        //   setContent(e);
        // }
      },
    ]);
  }, [mode]);


  const _submit = (form) => {
    const body = {
      ...form,
      date: form.date[0]
    };
    if (mode === "detail") {
      delete body.content;
      systemAlert(`"${form.title}"뉴스레터 정보를 수정하시겠습니까?`, {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '수정',
            onClick: () => {
              editBoard(body, form.idx)
                .then(res => {
                  toast.success("수정되었습니다.");
                  cancel();
                  submit && submit();
                }).catch((err) => {
                  console.error(err.response);
                });
            }
          }
        ]
      });

    } else {
      addBoard(body).then(() => {
        toast.success("등록되었습니다.");
        cancel();
        submit && submit();
      }).catch((err) => {
        console.error(err.response);
      });
    }
  };


  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setOriginForm,
    setValidateFields,
  } = useForm(
    defaultForm,
    _submit,
  );

  useEffect(() => {
    setValidateFields(fields);
    setMode(selectedItem ? 'detail' : 'create');
    if (selectedItem) {
      setForm({
        ...selectedItem,
        isHide: selectedItem.isHide + "",
        isEmail: selectedItem.isEmail + "",
      });
      setOriginForm({
        ...selectedItem,
        isHide: selectedItem.isHide + "",
        isEmail: selectedItem.isEmail + "",
      });
    } else {
      setForm(defaultForm);
      setOriginForm(defaultForm);
    }
  }, [open, selectedItem]);

  return (
    <Modal
      isOpen={open}
      close={cancel}
    >
      <div className="item-write">
        <ModalHeader>
          {selectedItem &&
            <>"{selectedItem.title}"
            </>} 뉴스레터 {mode === "create" ? "신규 등록" : "수정"}
        </ModalHeader>

        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={mode === 'create' ? '등록' : '수정'}
          submit={handleSubmit}
          cancel={cancel}
        />
      </div>

    </Modal>
  );
};

export default Board;